import { validateSecureData, clearInvalidData } from '../security/secureStorage';
import cryptoService from '../security/cryptoService';

const SECURE_KEYS = ['USERNAME', 'USERID', 'PROFILE', 'USERTOKEN', 'CURRENTPROFILE'];

const saveSession = async (storeAndValueMap) => {
  for (const [key, value] of Object.entries(storeAndValueMap)) {
    if (SECURE_KEYS.includes(key)) {
      try {
        const encrypted = await cryptoService.encryptData(value);
        window.sessionStorage.setItem(key, JSON.stringify({
          encrypted: true,
          ...encrypted
        }));
      } catch (error) {
        console.error(`Error encrypting ${key}:`, error);
        window.sessionStorage.setItem(key, JSON.stringify({
          encrypted: false,
          value
        }));
      }
    } else {
      window.sessionStorage.setItem(key, JSON.stringify({
        encrypted: false,
        value
      }));
    }
  }
};

const getSession = async (keyName) => {
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(keyName));
    if (!stored) return null;

    if (stored.encrypted) {
      return await cryptoService.decryptData(
        stored.data,
        stored.iv,
        stored.key
      );
    }
    return stored.value;
  } catch (error) {
    console.error(`Error getting session data for ${keyName}:`, error);
    return null;
  }
};

const saveSameAsStore = async (applicationStore) => {
  await saveSession(_getMutationsAndValuesMap(applicationStore));
};

const clearStorage = (applicationStore) => {
  saveSession(_getMutationsMap(applicationStore));
  window.sessionStorage.clear();
};

// Helpers existentes mantidos como estão
const _getMutationsMap = (applicationStore) => {
  const mappedObject = {};
  Object.keys(applicationStore.getters).forEach(getter => {
    mappedObject[getter] = null;
  });
  return mappedObject;
};

const _getMutationsAndValuesMap = (applicationStore) => {
  const mappedObject = {};
  Object.keys(applicationStore.getters).forEach(getter => {
    mappedObject[getter] = applicationStore.getters[getter];
  });
  return mappedObject;
};

export { saveSession, getSession, saveSameAsStore, clearStorage };
